import { useTranslation } from "react-i18next";

import { PublicNotFound } from "src/components/PublicNotFound";

export function PublicProfileNotFound() {
  const { t } = useTranslation();

  return (
    <PublicNotFound
      title={t("publicProfileNotFoundTitle")}
      description={t("publicProfileNotFoundDescription")}
    />
  );
}
